export default __webpack_public_path__ + "static/media/Master Control.9aeb8a36.jpg";